import React from "react";

export default function Landing() {
  return (
    <img height="100%" width="100%" src="Foodsurf.png" alt="truck and logo" />
  );
}
